import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'AiraLabelPipe',
    standalone: false
})
export class AiraLabelPipe implements PipeTransform {

  transform(inputString: string): string {
    if (!inputString) {
      return '';
    }

    // First, remove any AiraXX tokens but preserve surrounding whitespace.
    const processedString = String(inputString).replace(/Aira\d+/g, '');

    // If it's not a confidence label, we're done.
    if (!/^\s*confidence:/i.test(processedString)) {
      return processedString;
    }

    // It is a confidence label, so format it to be more human-friendly.
    const suffix = processedString.replace(/^\s*confidence:/i, '').trim();
    return suffix ? `Confidence (${suffix})` : 'Confidence';
  }
}
